import React from 'react';
import './App.css';
import MainLayout from './components/Main layout';
import { Layout, Content } from 'react-mdl';

function App() {
  return (
    <div>
      <Layout>
        <MainLayout />
      </Layout>
    </div>
  );
}

export default App;
